import React from 'react';
import styles from './style.module.css';
import StepNineForm from '../../components/forms/step-nine';

export default () => (
    <div className={styles.page}>
        <h1 className={styles.mainTitle}>Estimated Closing Costs</h1>
        <p className={styles.text}>Homebuying comes with many costs; being prepared helps you feel more comfortable as you approach the finish line.</p>
        <StepNineForm/>
    </div>
);
